import noop from 'lodash/noop';

import { BUTTON_SIZES, Button, SecondaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

const TEST_TAG = 'confirm-update-display-until-modal';
export const CONFIRMATION_MODAL = TEST_TAG;
export const CONFIRMATION_MODAL_DISCARD_BUTTON = `${TEST_TAG}-discard-button`;
export const CONFIRMATION_MODAL_CONFIRM_BUTTON = `${TEST_TAG}-confirm-button`;

interface ConfirmationModalProps {
  /** Callback when "save changes" has been pressed */
  onConfirm?: () => void;
  /** Callback when "discard" has been pressed */
  onDiscard?: () => void;
  /** Callback when the modal has been closed */
  onClose?: () => void;
}

const ConfirmationModal = ({
  onConfirm = noop,
  onDiscard = noop,
  onClose = noop,
}: ConfirmationModalProps) => {
  const handleDiscard = () => {
    onDiscard();
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      data-test={CONFIRMATION_MODAL}
      id={CONFIRMATION_MODAL}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
      isModalOpen
      withPortal
    >
      <ModalHeader>Unsaved changes</ModalHeader>
      <ModalBody>Display until has been edited. Do you want to save your changes?</ModalBody>
      <ModalFooter onClose={onClose}>
        <SecondaryButton
          size={BUTTON_SIZES.LARGE}
          data-test={CONFIRMATION_MODAL_DISCARD_BUTTON}
          onClick={handleDiscard}
        >
          Discard changes
        </SecondaryButton>
        <Button
          size={BUTTON_SIZES.LARGE}
          data-test={CONFIRMATION_MODAL_CONFIRM_BUTTON}
          onClick={handleConfirm}
        >
          Save changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
